import type { ChangeEvent, ReactNode } from 'react';

import type { InputProps } from './Input';
import Input from './Input';
import Button from './Button';
import ButtonGroup from './ButtonGroup';
import { General } from '../StrokeIcons';

export default function InputWithXMark({
  value,
  className,
  size,
  onChange,
  buttons,
  ...props
}: InputProps & { buttons?: ReactNode }) {
  return (
    <ButtonGroup size={size} className={className}>
      <Input value={value} onChange={onChange} className="flex-1 min-w-0" {...props} />
      {buttons}
      {!!value && onChange != null && (
        <Button
          type="button"
          icon={<General.XMark />}
          onClick={() => onChange({ target: { value: '' } } as ChangeEvent<HTMLInputElement>)}
          text
        />
      )}
    </ButtonGroup>
  );
}
